import {
  SeuCalculationUnitItem,
  SeuComputationCombination,
  SeuIcon,
  SeuOfferUser,
} from '@seu-types';

export type SeuEditSession = {
  id: string;
  editor?: SeuOfferUser;
  start?: string;
  end?: string;
};

export type SeuChangelogItemType =
  | 'DETAILS_CHANGED'
  | 'PROJECT_NAME_CHANGED'
  | 'OPERATING_CONDITION_CHANGED'
  | 'OPERATING_CONDITION_ADDED'
  | 'OPERATING_CONDITION_REMOVED'
  | 'OPEX_CHANGED'
  | 'EMISSION_LIMITS_CHANGED'
  | 'GLOBAL_PARAMETER_SET_SET_AS_DEFAULT'
  | 'GLOBAL_PARAMETER_SET_ADDED'
  | 'GLOBAL_PARAMETER_SET_CHANGED'
  | 'GLOBAL_PARAMETER_SET_REMOVED'
  | 'COMPONENT_ADDED'
  | 'COMPONENT_REMOVED'
  | 'COMPONENT_CONFIGURATION_CHANGED'
  | 'CALCULATION_COMBINATION_CHANGED'
  | 'CALCULATION_COMBINATION_ADDED'
  | 'CALCULATION_COMBINATION_REMOVED'
  | 'CHANGES_IN_CANVAS'
  | 'COMPONENT_DRAGGED_INTO_CANVAS'
  | 'COMPONENT_REMOVED_FROM_CANVAS'
  | 'COMPONENT_NAME_CHANGED_IN_CANVAS'
  | 'INTERCONNECTION_ADDED'
  | 'INTERCONNECTION_UPDATED'
  | 'INTERCONNECTION_REMOVED'
  | 'INTERCONNECTION_DUPLICATED'
  | 'STREAM_ADDED'
  | 'STREAM_REMOVED'
  | 'STREAM_NAME_CHANGED'
  | 'REVISION_LOADED'
  | 'REVISION_CREATED';

export type SeuChangelogItem = {
  id: string;
  type: SeuChangelogItemType;
  editSessionId?: string;
  changes: SeuChangelogChange[];
  createdAt?: string;
  configKey?: string;
  itemName?: string;
};

export type SeuChangelogItemIconColors =
  | 'yellow'
  | 'petrol'
  | 'purple'
  | 'orange';

export type SeuChangelogItemIcon = {
  name: SeuIcon;
  color: SeuChangelogItemIconColors;
};

export type SeuChangelogListItem = {
  id: string;
  type: SeuChangelogItemType;
  icon: SeuChangelogItemIcon;
  title: string;
  createdAt?: string;
  hasChevronRight?: boolean;
};

export type SeuChangelogChangeValue =
  | string
  | SeuCalculationUnitItem
  | SeuComputationCombination[]
  | undefined
  | null;

export type SeuChangelogChange = {
  fieldName: string;
  oldValue?: SeuChangelogChangeValue;
  newValue?: SeuChangelogChangeValue;
  flag: SeuChangelogChangeFlag;
};

export type SeuChangelogChangesGroup = {
  flag: SeuChangelogChangeFlag;
  changes: SeuChangelogChange[];
};

export type SeuChangelogChangeFlag = 'new' | 'changed' | 'deleted';

export const SEU_CHANGELOG_TYPES_WITH_DETAILS: SeuChangelogItemType[] = [
  'DETAILS_CHANGED',
  'OPERATING_CONDITION_ADDED',
  'OPERATING_CONDITION_CHANGED',
  'OPEX_CHANGED',
  'EMISSION_LIMITS_CHANGED',
  'GLOBAL_PARAMETER_SET_ADDED',
  'GLOBAL_PARAMETER_SET_CHANGED',
  'COMPONENT_CONFIGURATION_CHANGED',
  'CALCULATION_COMBINATION_CHANGED',
];
